import { render, staticRenderFns } from "./RockyMountainPowerDisclosure.vue?vue&type=template&id=f39f4830&"
import script from "./RockyMountainPowerDisclosure.vue?vue&type=script&lang=js&"
export * from "./RockyMountainPowerDisclosure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports